export default {"src":"/_next/static/media/wizama.ec29f1b1.svg","height":55,"width":189};